import {
    EVENT_INITIATORS,
    INTERACTION_TYPES,
} from '@zocdoc-frontend-common/utils-frontend-metrics';
import { useEffectOnce } from '@zocdoc-frontend-common/utils-react';
import logToDataDog from 'src/config/logToDataDog';

/**
 * @description Fires view screen metrics to Datadog and PEDL and scrolls to the
 * top of the page in case the user scrolled down on the previous page
 * @param {string} loadActionName
 * @param {string} loadMetricName
 * @param {function} sendMetric
 */
export const useLoadCreateAccountView = ({
    loadActionName,
    loadMetricName,
    sendMetric,
}) => {
    // Metrics that should only fire once
    useEffectOnce(() => {
        // Datadog metric for view count at a glance
        logToDataDog({
            name: loadMetricName,
            type: 'increment',
            value: 1,
        });

        /* Scroll back to top on page load; if the user scrolled
         * down to complete the form on the previous page, we don't
         * want to start them off at that random scroll point here.
         */
        window.scrollTo(0, 0);

        sendMetric({
            action: loadActionName,
            initiator: EVENT_INITIATORS.SYSTEM,
            interactionType: INTERACTION_TYPES.LOAD,
        });
    });
};
